module.exports = __webpack_public_path__ + "images/text/sorry_b26f8be36c82334c877a58e136d85fba.png";